import { IS_INTEGRATED_VERSION } from '../../config/ConfigManager'
import { AwsAuth } from './AwsAuth'
import { EmbeddedAuth } from './EmbeddedAuth'

export default IS_INTEGRATED_VERSION ? new EmbeddedAuth() : new AwsAuth()
